import forge from 'node-forge'

import {getRSAPublicKey} from './rsaEncryption'

export interface Credentials {
  email: string
  password: string
}

export interface EncryptedCredentials {
  email: string
  password: string
}

type EncryptedData = string

const encrypt = (data: string): EncryptedData => {
  const publicKey = forge.pki.publicKeyFromPem(getRSAPublicKey() || '')

  // Encrypt data using RSA-OAEP
  const encrypted = publicKey.encrypt(forge.util.encodeUtf8(data), 'RSA-OAEP')

  // Return base64-encoded encrypted data
  return forge.util.encode64(encrypted)
}

export const shouldShowLoginDialog = (
  loginDialogOpen: boolean,
  credentialsFromCookie: string | null
) => !loginDialogOpen && !credentialsFromCookie

export const processCredentials = (
  credentials: Credentials | null | undefined,
  credentialsFromCookie: Credentials | null
) => {
  if (!credentials && !credentialsFromCookie) return null

  if (!credentials && credentialsFromCookie) {
    return credentialsFromCookie
  }

  if (credentials && !credentialsFromCookie) {
    const encryptedPassword = encrypt(credentials.password)
    const encryptedCredentials = {...credentials, password: encryptedPassword}
    return encryptedCredentials
  }
}
